package de.oevbs.kunde.kundenportal2.services.digiservicecard.store

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.model.services.digiservicecard.DigitalServiceCard
import de.oevbs.kunde.kundenportal2.model.services.digiservicecard.DigitalServiceCardInit
import de.oevbs.kunde.kundenportal2.services.digiservicecard.DigitalServiceCardClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.use
import dev.fritz2.core.SimpleHandler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class DigitalServiceCardStore(job: Job) : ValidatingStore<DigitalServiceCardInit, Unit, ComponentValidationMessage>(
    initialData = DigitalServiceCardInit(),
    validation = DigitalServiceCardInit.validation,
    validateAfterUpdate = false,
    metadataDefault = Unit,
    job = job
) {

    private val client = DigitalServiceCardClient().use(PortalSessionMiddleware)

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val currentStep: Flow<GeneralProgressStep> = progressStore.data

    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    val requestDigiCard: SimpleHandler<Unit> = handle { currentModel ->

        GlobalServiceMessagesStore.clear()

        if (!validate(currentModel).valid) {
            return@handle currentModel
        }

        val success = globalSubmitTracker.track {
            requestCard(
                DigitalServiceCard(
                    currentModel.selectedContract!!,  // Validation prüft auf null
                    currentModel.allowPushNotifications
                )
            )
        }

        if (success) progressStore.update(GeneralProgressStep.SUCCESS2)

        // Das Model wird noch zum Erstellen einer MessagePage benötigt
        currentModel
    }

    val init: SimpleHandler<Unit> = handle { currentModel ->
        GlobalServiceMessagesStore.clear()
        globalInitTracker.track {
            val initData = initCarContracts()
            if (initData == null) {
                initFailedStore.update(true)
                return@track currentModel
            }
            initData
        }
    }

    private suspend fun requestCard(model: DigitalServiceCard): Boolean {
        tryCatchAndHandleErrors("Anfordern einer digitalen Kfz-Servicekarte") {
            client.createCard(model)
        } ?: return false
        return true
    }

    private suspend fun initCarContracts(): DigitalServiceCardInit? {
        return tryCatchAndHandleErrors("Initialisieren der digitalen Kfz-Servicekarte") {
            client.init()
        }
    }

    private fun testData(): DigitalServiceCardInit {
        return DigitalServiceCardInit(
            listOf(
                CarContract("24389", "PKW", "BS AU 345"),
                CarContract("2222289", "Anhänger", "OHA DA 1234"),
                CarContract("11345235", "Lastkraftwagen", "B EN 1")
            ),
            "test@öfi.de",
            null,
            false
        )
    }
}